import { baseURL } from '../httpService/API';
import { hMacAjax } from 'grt-tool-lib-front';

const reqUri = `${baseURL}/grt-user-center-service`,

 uri = {
    collectList: `${reqUri}/user/favorite/list`,
    cancelCollect: `${reqUri}/user/favorite/cancel`,
    favoriteCountList: `${reqUri}/user/favorite/count`
};

//获取我的收藏列表
export const getCollectList = (data) => {
    return hMacAjax.post(uri.collectList, data);
};

//取消收藏
export const cancelCollect = (data) => {
    return hMacAjax.post(uri.cancelCollect, data);
};
//获取我的收藏列表
export const getFavoriteCountListReq = () => {
    return hMacAjax.post(uri.favoriteCountList);
};
